import { axios } from '~/axios'

import type { ListDynamicLinksInput } from '../types/list-dynamic-links-input.type'
import type { SurveyDynamicModel } from '../types/survey-dynamic-model.type'
import type { UpdateDynamicLinkInput } from '../types/update-dynamic-survey-input.type'

export const dynamicLinkService = {
  /**
   * Mutation: Update dynamic link
   */
  async updateDynamicLink(input: UpdateDynamicLinkInput): Promise<boolean> {
    const response = await axios.post('/graphql', {
      query: `
        mutation UpdateDynamicLink(
          $id: Long!
          $status: String
          $toDate: String
        ) {
          updateDynamicLink(
            id: $id
            status: $status
            toDate: $toDate
          ) {
            successful
            entity
            infos
            warns
            errors
            content
          }
        }
      `,
      variables: input,
    })

    return response.data.data.updateDynamicLink.successful
  },

  /**
   * Query: List dynamic links
   */
  async listDynamicLinks(
    input: ListDynamicLinksInput,
  ): Promise<SurveyDynamicModel[]> {
    const response = await axios.post('/graphql', {
      query: `
        query ListDynamicLinks(
          $surveyDefinitionId: Long
          $createdDateFrom: String!
          $createdDateTo: String!
        ) {
          listDynamicLinks(
            surveyDefinitionId: $surveyDefinitionId
            createdDateFrom: $createdDateFrom
            createdDateTo: $createdDateTo
          ){
            id
            accessToken
            token
            surveyDefinition
            hub
            status
            createdBy
            createdDate
            toDate
            url
            env
            projects
            surveyCount
          }
        }
      `,
      variables: input,
    })

    return response.data.data.listDynamicLinks
  },
}
